import { hotMovies, newMovies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import { useState } from 'react';

type TabKey = 'hot' | 'new';

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState<TabKey>('hot');

  const movies = activeTab === 'hot' ? hotMovies : newMovies;

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">热门影片持续上新中</p>
          </div>

          <div className="flex items-center bg-background-100 rounded-full px-1 py-1">
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              热播榜
            </button>
            <button
              onClick={() => setActiveTab('new')}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === 'new'
                  ? 'bg-accent-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900'
              }`}
            >
              最新上线
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop>
          {movies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              titleEn={movie.titleEn}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              poster={movie.poster}
              slug={movie.slug}
            />
          ))}
        </div>
      </div>
    </section>
  );
}